import * as types from '../mutation-types'

const state = {
	active: {},
	all: []
}

const mutations = {
	[types.SET_SITE](state, site) {
		state.active = site;
	},

	[types.SET_SITES](state, sites) {
		state.all = sites;
	}
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/sites.js